import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";

export class EventSpeakerModel extends Model {
    constructor(
        public name: string = "",
        public image: string = "",
        public jobTitle: string = "",
        public company: string = "",
        public workExperience: string[] = [],
        public link: string = "",
    ) {
        super();
    }

    public static create(model: Partial<EventSpeakerModel>): EventSpeakerModel {
        return createModel<EventSpeakerModel>(EventSpeakerModel, {
            ...model
        });
    }
}
